import axios, { AxiosError } from "axios";
import { custom } from 'devextreme/ui/dialog';
import { ErrorCodes } from "./errorCodes";

type ErrorType = 'auth' | 'generic';
interface CustomSettings {
    customErrorMessage: string,
    showButton: boolean,
    buttonText: string,
}

export const errorHandler = (err: any, type: ErrorType, customSettings?: CustomSettings) => {
    const errorCode = getErrorCode(err);

    if (type === "auth") {
        showAuthErrorDialog(errorCode)
    } else {
        showGenericErrorDialog(customSettings)
    }
}

const getErrorCode = (err: any) => {
    if (axios.isAxiosError(err)) {
        const axiosError = err as AxiosError;
        return axiosError.response?.data?.error_code;
    }

    return err.code;
};

const showAuthErrorDialog = (errorCode) => {
    const errorMessage = errorCode ? ErrorCodes[errorCode] : ErrorCodes['E_AUTH_GENERIC']

    const errorDialog = custom({
        title: "Não foi possível efetuar a autenticação",
        messageHtml: `<div style="width: 350px; height: 50px;">${errorMessage}</div>`,
        buttons: [{
            text: "Tentar Novamente",
            onClick: (e) => {
                return {buttonText: e.component.option("text")}
            }
        },
        ],
    });

    errorDialog.show().then((dialogResult) => {
        window.location.reload();
    });
}

const showGenericErrorDialog = (customSettings?: CustomSettings) => {
    const defaultErrorMessage = "Desculpe, ocorreu um erro ao processar a operação. Por gentileza tente novamente, se persistir entre em contato com o suporte."
    const errorDialog = custom({
        title: "Ocorreu um erro",
        messageHtml: `<div style="width: 350px; height: 50px;">${customSettings?.customErrorMessage ?? defaultErrorMessage}</div>`,
        buttons: [{
            text: customSettings?.buttonText ?? "Ok",
            visible: customSettings?.showButton ?? false,
            onClick: (e) => {
                return {buttonText: e.component.option("text")}
            }
        },]
    });

    errorDialog.show()
}
